<template>
    <div
        class="md-hero template1"
        :class="[`banner-with-${searchStyle}`]"
        :style="{ marginBottom }"
    >
        <banner
            ref="banner"
            :type="type"
            :mobileType="mobileType"
            :useMobileSettings="useMobileSettings"
            :sizeOption="sizeOption"
            :pictureOption="pictureOption"
            :mobilePicture="mobilePicture"
            :pictureListOption="pictureListOption"
            :mobilePictureListOption="mobilePictureListOption"
            :maskOption="maskOption"
            :videoOption="videoOption"
            :mobileVideoOption="mobileVideoOption"
        >
            <media-content
                :class="`media-content-${searchStyle}`"
                :type="contentType"
                :title="title"
                :imgAlign="imgAlign"
                :subTitle="subTitle"
                :titlePic="titlePic"
                :showShadow="showShadow"
                :layout="searchBarLayout"
                class="row2column"
            >
                <template #info>
                    <div
                        v-if="useType === 'video'"
                        class="play-video"
                        @click.stop="doVideoPlay"
                    ></div>
                </template>
                <div v-if="useType === 'video'" class="video-loading"></div>
                <div
                    class="media-content-box media-content-box-template1"
                    @click="avoidEmitMedia"
                >
                    <component
                        :is="searchBar"
                        v-if="searchStyle === 'search-bar'"
                        :needSearchCondition="true"
                        :configFilter="configFilter"
                        :placeholder="searchbarPlaceholder"
                        :submitText="computedSearchBtnText"
                        :class="searchBarLayout"
                        class="row2column"
                        :agreementData="agreementData"
                    />
                    <search-group
                        v-if="searchStyle === 'search-group'"
                        :needSearchCondition="false"
                        :searchGroupTabs="searchGroupTabs"
                        :searchGroupConfig="searchGroupConfig"
                        :nameType="nameType"
                        :nameRequired="nameRequired"
                        :phoneRequired="phoneRequired"
                        :class="searchBarLayout"
                        class="row2column"
                        :agreementData="agreementData"
                    />
                    <banner-button
                        v-if="searchStyle === 'search-btn'"
                        :buttons="buttons"
                        :class="searchBarLayout"
                        class="row2column"
                    />
                </div>
            </media-content>
        </banner>
    </div>
</template>

<script>
import common from '../index.js';
import mixinsSearchBar from './mixins-search-bar';
import MediaContent from '../../../components/media-content.vue';
import BannerButton from '../../../components/banner-button.vue';
import SearchGroup from './search-group.vue';
export default {
    mixins: [common, mixinsSearchBar],
    components: {
        MediaContent,
        BannerButton,
        SearchGroup
    }
};
</script>

<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

@mixin title-text {
    .title-text {
        .media-title {
            font-size: 30px;
            line-height: 36px;
        }

        .media-subtitle {
            font-size: 20px;
        }
    }
}

@mixin search-by-section {
    .search-by-section {
        border-bottom: 1px solid var(--color-border);

        .search-category {
            box-shadow: none;

            .keyword-submit {
                min-width: 0;
                color: #a0a1b4;
                background-color: #fff;

                .search-text {
                    display: none;
                }
            }
        }
    }
}

.md-hero.template1 {
    &.banner-with-search-bar {
        @include media-800 {
            .media-content {
                position: static;

                @include title-text;

                .search-bar {
                    margin-top: 45px;
                }
            }
        }
    }

    &.banner-with-search-group {
        @include media-800 {
            .media-content {
                .search-group {
                    margin-top: 20px;
                    padding-bottom: 20px;
                }
            }
        }
        .media-content.column .media-info:before {
            height: calc(100% + 60px);
        }
        @include media-1080 {
            .media-content.row2column .media-info:before {
                height: calc(100% + 60px);
            }
        }
    }

    &.banner-with-search-btn {
        .banner-button {
            width: 100%;
            flex-direction: row;
            justify-content: center;
            &.count-4 {
                max-width: 900px;
            }
            @include media-min-1080 {
                &.row {
                    width: 50%;
                    flex-direction: column;
                    align-items: flex-end;
                    .btn-item {
                        width: 400px;
                    }
                }
            }
            .btn-item {
                min-width: 280px;
                padding: 0 15px;
                margin: 30px 15px 0;
                font-size: 16px;
                border-radius: 4px;
                height: 56px;
                line-height: 52px;
                border-width: 2px;
                &:first-child {
                    background-color: var(--mg-button-background);
                    border-color: var(--mg-button-background);
                }
                @include media-1080 {
                    min-width: 168px;
                    padding: 0 10px;
                    height: 32px;
                    line-height: 28px;
                    text-shadow: none;
                }
            }
            @include media-800 {
                display: inline-block;
                width: auto;
                max-width: 100%;
                .btn-item {
                    width: 100%;
                    margin: 20px 0 0;
                    min-width: 195px;
                    padding: 0 5px;
                    border-radius: 3px;
                    height: 36px;
                    line-height: 32px;
                    font-size: 14px;
                    font-family: var(--font-bold);
                }
            }
        }
        .media-content.column .media-info:before {
            content: none;
        }
        @include media-1080 {
            .media-content.row2column .media-info:before {
                content: none;
            }
        }
        .media-content-box {
            text-align: center;
        }
    }

    .media-content {
        width: 1080px;
        max-width: calc(100% - 30px);
        z-index: calc(var(--level-sublow) + 1);
        &.column {
            .media-info {
                position: relative;
            }
        }
        @include media-1080 {
            &.row2column {
                .media-info {
                    position: relative;
                }
            }
        }

        .media-info {
            width: 100%;
            max-width: 100%;
        }
        .title-text {
            padding-top: 0;
            .media-title {
                word-break: break-word;
                text-shadow: 0 1px 3px rgba(32, 36, 55, 0.3);
                font-weight: bold;
            }
            .media-subtitle {
                margin-top: 20px;
                text-shadow: 0 1px 2px rgba(32, 36, 55, 0.3);
                overflow: hidden;
            }
        }
        &.media-content-search-btn,
        &.media-content-search-group {
            .title-text .media-shadow {
                display: none;
            }
        }
        @include media-1080 {
            .title-text {
                .media-title {
                    font-size: 38px;
                    line-height: 45px;
                }
                .media-subtitle {
                    font-size: 17px;
                }
            }
        }

        @include media-600 {
            .title-text {
                padding: 0;
                .media-title {
                    font-size: 24px;
                    line-height: 26px;
                }
                .media-subtitle {
                    width: 254px;
                    margin: 8px auto 0;
                    font-size: 14px;
                }
                .media-shadow {
                    width: 300px;
                    top: 16px;
                }
            }
            .banner-button {
                margin-top: 18px;
            }
        }
    }
    .banner-video + .media-content {
        .title-text .media-shadow {
            display: none;
        }
        @include media-min-1080 {
            &.row {
                .play-video {
                    margin: 10px auto;
                }
            }
        }
        .play-video {
            margin: 10px auto 10px;
            width: 84px;
            height: 84px;
            border-radius: 50%;
            background-image: url(//static.chimeroi.com/site3/images/play.png);
            background-repeat: no-repeat;
            background-size: cover;
            position: relative;
            cursor: pointer;
            pointer-events: all;
            &:before {
                content: '';
                position: absolute;
                left: -7px;
                top: -7px;
                width: calc(100% + 14px);
                height: calc(100% + 14px);
                border-radius: 50%;
                background-color: rgba(255, 255, 255, 0.4);
            }
            @include media-1080 {
                width: 60px;
                height: 60px;
            }
            @include media-600 {
                width: 40px;
                height: 40px;
                &:before {
                    left: -4px;
                    top: -4px;
                    width: calc(100% + 8px);
                    height: calc(100% + 8px);
                }
            }
        }
        .video-loading {
            display: none;
            width: 80px;
            height: 80px;
            background: url(//static.chimeroi.com/site/images/home/loading.gif)
                no-repeat;
            background-size: cover;
            @include media-1080 {
                width: 60px;
                height: 60px;
            }
            @include media-600 {
                width: 40px;
                height: 40px;
            }
        }
    }
    .banner-video.autoplay + .media-content,
    .banner-video.is-play + .media-content {
        .video-loading {
            display: none;
        }
        .play-video {
            display: none;
        }
    }
    .banner-video.loading + .media-content {
        .video-loading {
            display: block;
        }
        .play-video {
            display: none;
        }
    }
    .banner-video.is-play ~ .banner-mask {
        display: none;
    }
    .column .media-content-box {
        width: 100%;
        &.media-content-box-template1 {
            width: 90%;
        }
    }
    @include media-1080 {
        .row2column .media-content-box {
            width: 100%;
            &.media-content-box-template1 {
                width: 90%;
            }
        }
    }
    @include media-min-1080 {
        .row .media-content-box {
            width: auto;
        }
    }
    .banner-video {
        .play-video,
        .video-loading {
            display: none;
        }
    }
    .swiper-horizontal > .swiper-pagination-bullets {
        bottom: 20px;
        .swiper-pagination-bullet {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            margin-left: 6px;
            margin-right: 6px;
            background-color: white;
            opacity: 0.5;
            &.swiper-pagination-bullet-active {
                opacity: 1;
            }
        }
    }
}
</style>
